import Source from '../components/Source'
import LicenseFileLocations from './fragments/LicenseFileLocations'
import { Page } from './types'

type CreateClusterManagerClientLicenseProps = {
    os: string
    isContainer: boolean
}

const render = ({ os, isContainer }: CreateClusterManagerClientLicenseProps) => <>
     <p>When Gurobi is called from your code, it must know where to find the Cluster Manager that can
        accept your model and hand it over to a Compute Server that solves it. For this you can create
        a client license. The license does not contain a real license key, but instead points to your
        Cluster Manager. You need to specify at least the <code>CSMANAGER</code> parameter. On top of that,
        you either need a combination of <code>USERNAME</code> and <code>PASSWORD</code>, or an
        <code>CSAPIACCESSID</code> with corresponding <code>CSAPISECRET</code>.
    </p>
    <p>Here is an example of the simplest Cluster Manager client license file.</p>
    <pre>
        CSMANAGER=http://mymanager:61080<br/>
        CSAPIACCESSID=0e8c35d5-ff20-4e5d-a639-10105e56b264<br/>
        CSAPISECRET=d588f010-ad47-4310-933e-1902057661c9
    </pre>
    <LicenseFileLocations os={os} isContainer={isContainer} description='client license file'/>
    <Source href="https://www.gurobi.com/documentation/{version}/remoteservices/client_license_file.html"/>
</>

const CreateClusterManagerClientLicense : Page<CreateClusterManagerClientLicenseProps> = { key: 'create-cluster-manager-client-license', title: 'Creating a Cluster Manager client license', render }

export default CreateClusterManagerClientLicense